import canUseDOM from './canUseDOM'

export const getServerSideURL = () => {
  // Prefer explicit env config first
  let url = process.env.NEXT_PUBLIC_SERVER_URL || process.env.WEBSITE_URL

  // Vercel envs
  if (!url && process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`.replace(/\/$/, '')
  }
  if (!url && process.env.VERCEL_PROJECT_PRODUCTION_URL) {
    return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`.replace(/\/$/, '')
  }

  // Generic HOST + PORT fallback if provided
  if (!url && process.env.HOST && process.env.PORT) {
    return `http://${process.env.HOST}:${process.env.PORT}`.replace(/\/$/, '')
  }

  // Final fallback
  if (!url) {
    url = 'http://localhost:3000'
  }

  return url.replace(/\/$/, '')
}

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  if (process.env.VERCEL_PROJECT_PRODUCTION_URL) {
    return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
  }

  return process.env.NEXT_PUBLIC_SERVER_URL || ''
}
